module.exports = __webpack_public_path__ + "static/media/Escape your evasions.23e6eb75.pdf";